import React, { useState, useEffect, useContext } from "react";
import { DashboardContext } from "../../../context/DashboardContext";
import { GeneralContext } from "../../../context/GeneralContext";
import "./loop.scss";
import { FormattedText, hasProperty, getTextWithTooltip } from "../../../utils/helpers";
import {
  //deepCopy,
  getModelById,
  //replaceModelById,
} from "../../leftSide/Models/modelLogic";

function ParameterSelector(props) {
  const { model, handleSelectClicked } = props;
  const { recordedErrorLog } = useContext(GeneralContext);
  const { modelData, trackedParameters } = useContext(DashboardContext);

  // Helper function to check if a parameter is tracked
  const isParameterTracked = (param, isRec, rowIndex, lineshapeIndex) => {
    const modelSet = trackedParameters.find(ms => ms.FE_ID === model.FE_ID);
    if (!modelSet) return false;
    
    return modelSet.selectedParams.some(trackedParam => 
      trackedParam.speqqle_id === param.speqqle_id &&
      trackedParam.rowIndex === rowIndex &&
      trackedParam.lineshape_id === lineshapeIndex
    );
  };

  const [nonRecTables, setNonRecTables] = useState([]);
  const [recTable, setRecTable] = useState([]);
  const [recTableHeaders, setRecTableHeaders] = useState([]);
  const [lineshapeTable, setLineshapeTable] = useState([]);
  const [lineshapeTableHeaders, setLineshapeTableHeaders] = useState([]);

  useEffect(() => {
    try {
      if (model) {
        let nonRecTablesToPut = [];
        let recTableToPut = [];
        let lineshapeTableToPut = [];
        let lineshapeTableHeadersToPut = [];
        if (hasProperty(model, "modelParams")) {
          for (let i = 0; i < model.modelParams.length; i++) {
            const parameter = model.modelParams[i];

            if (parameter.recuring === 0) {
              //We select just non recuring parameters here
              let arrayToPut;
              if (nonRecTablesToPut[parameter.displaytable] !== undefined) {
                arrayToPut = nonRecTablesToPut[parameter.displaytable];
                arrayToPut[parameter.displayposition] = parameter;
              } else {
                arrayToPut = [];
                arrayToPut[parameter.displayposition] = parameter;
              }
              nonRecTablesToPut[parameter.displaytable] = arrayToPut;
            }
          }
        }

        if (hasProperty(model, "recParams")) {
          for (let i = 0; i < model.recParams.length; i++) {
            const paramRow = model.recParams[i];

            const rowOfParameters = [];
            const rowOfHeaders = [];
            for (let j = 0; j < paramRow.length; j++) {
              const parameter = paramRow[j];

              if (i === 0) {
                if (parameter.type === "Model" && !hasProperty(parameter, "name")) {
                  rowOfHeaders[parameter.displayposition] = "Model";
                } else {
                  rowOfHeaders[parameter.displayposition] = parameter.name;
                }
              }

              if (parameter.type === "Model") {
                const modelInParam = getModelById(parameter.FE_ID, modelData);
                rowOfParameters[parameter.displayposition] = {
                  ...parameter,
                  value: modelInParam.displayName,
                };
              } else {
                rowOfParameters[parameter.displayposition] = {
                  ...parameter,
                  value: model.recTableRows[i][parameter.name],
                };
              }
            }

            if (i === 0) {
              setRecTableHeaders(rowOfHeaders);
            }

            recTableToPut.push(rowOfParameters);
          }
        }

        if (hasProperty(model, "lineshapeData") && model.lineshapeData.length > 0) {
          for (let l = 0; l < model.lineshapeData.length; l++) {
            const lineShape = model.lineshapeData[l];
            if (!hasProperty(lineShape, "lineParams")) {
              continue;
            }
            const lineshapeTableContent = []
            for (let i = 0; i <lineShape.lineParams.length; i++) {
              const paramRow = lineShape.lineParams[i];
  
              const rowOfParameters = [];
              const rowOfHeaders = [];
              for (let j = 0; j < paramRow.length; j++) {
                const parameter = paramRow[j];
  
                if (i === 0) {
                    rowOfHeaders[parameter.displayposition] = parameter.name;
                }
                 rowOfParameters[parameter.displayposition] = {
                   ...parameter,
                   value: parameter.value || parameter.default,
                   lineshape_id: lineShape.lineshape_id,
                 };
              }
              if (i==0){
                lineshapeTableHeadersToPut.push(rowOfHeaders);
              }
              lineshapeTableContent.push(rowOfParameters);
            }
            lineshapeTableToPut.push(lineshapeTableContent);
          }
        }
        setLineshapeTableHeaders(lineshapeTableHeadersToPut);
        setLineshapeTable(lineshapeTableToPut);
        setRecTable(recTableToPut);
        setNonRecTables(nonRecTablesToPut);
      }
    } catch (error) {
      recordedErrorLog(
        "Error producing tables for parameter selection: ",
        error
      );
    }
  }, [model]);

  const handleNonRecCellClick = (cell) => {
    if (
      cell.type !== "Model" &&
      !((hasProperty(cell, "customFixed") && cell.customFixed) || cell.fixed)
    ) {
      handleSelectClicked(model, false, cell);
    }
  };

  const handleRecCellClick = (rowIndex, cell) => {
    if (
      cell.type !== "Model" &&
      !((hasProperty(cell, "customFixed") && cell.customFixed) || cell.fixed)
    ) {
      handleSelectClicked(model, true, cell, rowIndex);
    }
  };

  const handleLineshapeCellClick = (lineshapeIndex, rowIndex, cell) => {
    if (
      !((hasProperty(cell, "customFixed") && cell.customFixed) || cell.fixed)
    ) {
      handleSelectClicked(model, true, cell, rowIndex, lineshapeIndex);
    }
  };

  return (
    <div className="parameterSelector">
      <div className="header">
        <div className="title">{getTextWithTooltip(model.displayName, 20)}</div>
      </div>
      <div className="content">
        <div className="nonRecArea">
          {nonRecTables.map((tableEntry, tableIndex) => {
            const headers = tableEntry.map((tableCell) => {
              return tableCell.name;
            });

            return (
              <table className="nonRecTable" key={tableIndex}>
                <thead className="nonRecHeader">
                  <tr className="nonRecHeadRow">
                    {headers.map((headerEntry, headerIndex) => {
                      return (
                        <th className="nonRecHeadEntry" key={headerIndex}>
                          <FormattedText input={headerEntry} />
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody className="nonRecTbody">
                  <tr className="nonRecRow">
                    {tableEntry.map((tableCell, cellIndex) => {
                      return (
                        <td
                          className={`nonRecCell${
                            tableCell.type !== "float" &&
                            tableCell.type !== "int"
                              ? " disabled"
                              : ""
                          }${
                            isParameterTracked(tableCell, false, null, null)
                              ? " selected"
                              : ""
                          }${
                            (hasProperty(tableCell, "customFixed") &&
                              tableCell.customFixed) ||
                            tableCell.fixed
                              ? " disabled fixed"
                              : ""
                          }`}
                          onClick={() => handleNonRecCellClick(tableCell)}
                          key={cellIndex}
                        >
                          {tableCell.type !== "Checkbox" ? (
                            tableCell.value
                          ) : (
                            <input
                              type="checkbox"
                              defaultChecked={tableCell.value}
                              disabled
                            />
                          )}
                        </td>
                      );
                    })}
                  </tr>
                </tbody>
              </table>
            );
          })}
        </div>
        {recTableHeaders.length > 0 && (
          <div className="recArea">
            <table>
              <thead className="recHeader">
                <tr className="recHeadRow">
                  {recTableHeaders.map((headerEntry, headerIndex) => {
                    return (
                      <th className="recHeadEntry" key={headerIndex}>
                        <FormattedText input={headerEntry} />
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <tbody className="recTbody">
                {recTable.map((row, rowIndex) => {
                  return (
                    <tr className="recRow" key={rowIndex}>
                      {row.map((tableCell, cellIndex) => {
                        return (
                          <td
                            className={`recCell${
                              tableCell.type !== "float" &&
                              tableCell.type !== "int"
                                ? " disabled"
                                : ""
                            }${
                              isParameterTracked(tableCell, true, rowIndex, null)
                                ? " selected"
                                : ""
                            }${
                              (hasProperty(tableCell, "customFixed") &&
                                tableCell.customFixed) ||
                              tableCell.fixed
                                ? " disabled fixed"
                                : ""
                            }`}
                            onClick={() =>
                              handleRecCellClick(rowIndex, tableCell)
                            }
                            key={cellIndex}
                          >
                            {tableCell.type !== "Checkbox" ? (
                              tableCell.value
                            ) : (
                              <input
                                type="checkbox"
                                defaultChecked={tableCell.value}
                                disabled
                              />
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
        {lineshapeTableHeaders.length > 0 && (
          <div className="recArea">
            {lineshapeTableHeaders.map((headers, tableIndex) => {
              return (
                <table key={tableIndex}>
                  <thead className="recHeader">
                    <tr className="recHeadRow">
                      {headers.map((headerEntry, headerIndex) => {
                        return (
                          <th className="recHeadEntry" key={headerIndex}>
                            <FormattedText input={headerEntry} />
                          </th>
                        );
                      })}
                    </tr>
                  </thead>
                  <tbody className="recTbody">
                    {(lineshapeTable[tableIndex] || []).map((row, rowIndex) => {
                      return (
                        <tr className="recRow" key={rowIndex}>
                          {row.map((tableCell, cellIndex) => {
                            return (
                              <td
                                className={`recCell${
                                  tableCell.type !== "float" &&
                                  tableCell.type !== "int"
                                    ? " disabled"
                                    : ""
                                }${
                                  isParameterTracked(tableCell, true, rowIndex, tableCell.lineshape_id)
                                    ? " selected"
                                    : ""
                                }${
                                  (hasProperty(tableCell, "customFixed") &&
                                    tableCell.customFixed) ||
                                  tableCell.fixed
                                    ? " disabled fixed"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleLineshapeCellClick(tableCell.lineshape_id, rowIndex, tableCell)
                                }
                                key={cellIndex}
                              >
                                  {tableCell.type !== "Checkbox" ? (
                                    tableCell.value
                                  ) : (
                                    <input
                                      type="checkbox"
                                      defaultChecked={tableCell.value}
                                      disabled
                                    />
                                  )}
                                </td>
                              );
                            })}
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default ParameterSelector;
